module.exports = __webpack_public_path__ + "static/media/svg.e4d429af.svg";